
import React, { Suspense, useState, useEffect } from 'react';
import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';

interface SmartLazySectionProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  height?: string;
  className?: string;
  threshold?: number;
  rootMargin?: string;
}

const SmartLazySection: React.FC<SmartLazySectionProps> = ({
  children,
  fallback,
  height = 'h-96',
  className = '',
  threshold = 0.1,
  rootMargin = '100px'
}) => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold,
    rootMargin
  });
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true);
    }
  }, [isVisible]);

  const defaultFallback = (
    <div className={`${height} ${className} flex items-center justify-center bg-gray-50 animate-pulse`}>
      <div className="w-8 h-8 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
    </div>
  );

  return (
    <div ref={ref} className={className}>
      {shouldRender ? (
        <Suspense fallback={fallback || defaultFallback}>
          {children}
        </Suspense>
      ) : (
        <div className={`${height} bg-gray-50`} />
      )}
    </div>
  );
};

export { SmartLazySection };
